import { ApplicationConfig, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { NgcCookieConsentModule } from 'ngx-cookieconsent';
import { ToastrModule } from 'ngx-toastr';
import { LayoutModule } from '@angular/cdk/layout';
import { COOKIE_CONFIG } from '@core/models/cookie-consent.constant';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './routes';
import { NgxSpinnerModule } from 'ngx-spinner';
import { httpInterceptorProviders } from './core/interceptors/interceptors';
import { ColorInitializerProvider } from './core/providers/color-initializer.provider';
import { AgencyCoreInitializerProvider } from './core/providers/agency-core-initializer.provider';
import 'moment/locale/it';

export const appConfig: ApplicationConfig = {
  providers: [
    ColorInitializerProvider,
    AgencyCoreInitializerProvider,
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      })
    ),
    provideClientHydration(),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    httpInterceptorProviders,
    // External module imports
    { provide: MAT_DATE_LOCALE, useValue: 'it' },
    { provide: LOCALE_ID, useValue: 'it' },
    importProvidersFrom(
      NgxSpinnerModule.forRoot(),
      NgcCookieConsentModule.forRoot(COOKIE_CONFIG),
      ToastrModule.forRoot({
        positionClass: 'toast-top-right',
        progressAnimation: 'increasing',
      }),
      LayoutModule,
      MatNativeDateModule
    ),
    provideAnimations(),
  ],
};
